import React  from 'react';
import './index.scss';
import { Icon } from 'semantic-ui-react';
import { InfoMessage } from "dyl-components";
import { PhoneUtil } from 'utils';

const OfficeViewHeader = ({ state = 'idle', phoneNumber, currentCallTicker, callDirection, phoneErrors, isInternalCall }) => {
    return (
        <div className={`OfficeViewHeader ${state ? `OfficeViewHeader--${state}` : ""}`}>
            <div style={{flex: 1}}>
                {/* <div className='OfficeViewHeader__ball' /> //TODO: CER-4483: Figure out */}
                {(state === "ringing" || state === "active") &&
                <>
                    {/* <div className="OfficeViewHeader__line">1</div> //Removed  */}
                    <Icon className={`fa-solid ${state === "ringing" ? "fa-phone-volume" : isInternalCall ? "fa-people-pants-simple" : callDirection === "outbound" ? "fa-phone-arrow-up-right" : "fa-phone-arrow-down-left"} OfficeViewHeader__ringing-icon`} />
                    <div className="OfficeViewHeader__number">{!isInternalCall ? PhoneUtil.asYouTypeFormatter(phoneNumber, false) : `Ext. ${phoneNumber}`}</div>
                    <div className="OfficeViewHeader__time-ticker">{state === "active" && PhoneUtil.timeTicker(currentCallTicker)}</div>
                </>
                }
            </div>
            {phoneErrors && <InfoMessage content={phoneErrors} type='error' />}
            {/* <Icon className={"fa-solid fa-arrow-up-right-from-square OfficeViewHeader__icon"} /> TODO */}
        </div>
    )
};

export default OfficeViewHeader;